import 'angular';
import '@uirouter/angularjs';
import '../wwwroot/Scripts/angular-animate.min';
import '../wwwroot/Scripts/angular-cookies.min';
import '../wwwroot/Scripts/angular-cron-jobs.min';
import '../wwwroot/Scripts/angular-datatables/angular-datatables.min';
import '../wwwroot/Scripts/angular-datatables/plugins/bootstrap/angular-datatables.bootstrap.min';
import '../wwwroot/Scripts/angular-datatables/plugins/buttons/angular-datatables.buttons.min';
import '../wwwroot/Scripts/ngStorage.min';
import '../wwwroot/Scripts/angular-pageslide.min';
import '../wwwroot/Scripts/angular-resource.min';
import '../wwwroot/Scripts/angular-responsive-tables.min';
import '../wwwroot/Scripts/angular-sanitize.min';
import '../wwwroot/Scripts/angular-slim-scroll.min';
//import '../wwwroot/Scripts/angular-socialshare';
import 'angular-socialshare';
import '../wwwroot/Scripts/angular-translate.min';
import '../wwwroot/Scripts/angular-translate-loader-partial.min';
import '../wwwroot/Scripts/angular-translate-storage-cookie.min';
import '../wwwroot/Scripts/angular-translate-loader-static-files.min';
import '../wwwroot/Scripts/angular-ui/mask.min';
//import '../wwwroot/Scripts/angular-ui/ui-bootstrap-tpls';
import '../wwwroot/Scripts/angular-ui/sb-ui-bootstrap-tpls.min';
import '../wwwroot/Scripts/angular-ui/validate.min';
import '../wwwroot/Scripts/angular-timer.min';
import '../wwwroot/Scripts/angular-touch.min';
import '../wwwroot/Scripts/angular-pretty-checkable.min';
import '../wwwroot/Scripts/angular-money-directive.min';
import '../wwwroot/Scripts/ng-file-upload.min';
import '../wwwroot/Scripts/sb-ng-jcrop.min';
import '../wwwroot/Scripts/d3/d3.min';
import '../wwwroot/Scripts/ocLazyLoad';
import '../wwwroot/Scripts/pie-chart.min';
import '../wwwroot/Scripts/sb-angular-ellipsis.min';
import '../wwwroot/Scripts/sb-angular-notify.min';
//import '../wwwroot/Scripts/angular-ismobile';
//import '../wwwroot/Scripts/ngclipboard.min';
import '../wwwroot/Scripts/xeditable.min';
import '../wwwroot/Scripts/ngMeta.min';
import './dropzoneconfig';
import './common/services/common.services';
import './app';
//import './common/components/catalogAddToPlanButtom.component';
import './common/services/accountDashboardResource';
import './common/services/accountNotificationUnsubscribesResource';
import './common/services/accountNotificationSettingsResource';
import './common/services/accountOrdersResource';
import "./common/services/accountsFilterResource";
import './common/services/accountsResource';
import './common/services/activationFilesResource';
import './common/services/assignmentLearnerAccessAssignmentResource';
import './common/services/assignmentLearnerAccessDownloadsResource';
import './common/services/assignmentLearnerAccessExternalQualificationResource';
import './common/services/assignmentLearnerAccessLearningJournalResource';
import './common/services/assignmentLearnerAccessOnlineExamResource';
import './common/services/assignmentLearnerAccessOnlineLessonResource';
import './common/services/assignmentLearnerAccessPracticalEvaluationResource';
import './common/services/assignmentLearnerAccessResource';
import './common/services/assignmentLearnerAccessSBCourseResource';
import './common/services/assignmentLearnerAccessSeminarResource';
import './common/services/assignmentLearnerAccessUrlResource';
import './common/services/assignmentLearnerAccessWebinarResource';
import './common/services/assignmentLearnerAccessWorkHistoryResource';
import './common/services/assignmentMapsResource';
import './common/services/assignmentSeminarResource';
import './common/services/assignmentStatusResource';
import './common/services/authService';
import './common/services/bandResource';
import './common/services/calendarSettingsService';
//import './common/services/catalogResource';
import './common/services/catalogBannerResource';
import './common/services/categoryResource';
import './common/services/colorService';
import './common/services/connectionsResource';
import './common/services/cropPictureResource';
import './common/services/cropPictureService';
import './common/services/currencyConverterResource';
import './common/services/currencyService';
import './common/services/customCertificateResource';
import './common/services/dashboardResource';
import './common/services/discountResource';
import './common/services/examCategoryQuestionResource';
import './common/services/examCategoryResource';
import './common/services/examDetailsResource';
import './common/services/examQuestionFilesResource';
import './common/services/examQuestionResource';
import './common/services/examResource';
import './common/services/externalLoginConfigurationResource';
import './common/services/externalQualificationHistoryResource';
import './common/services/facebookService';
import './common/services/facilityResource';
import './common/services/gamificationNotificationService';
import './common/services/gamificationResource';
import './common/services/globalizationService';
import './common/services/groupHierarchyResource';
import './common/services/groupResource';
import './common/services/homePageService';
import './common/services/hubService';
import './common/services/learningItemAssignmentLocalizationResource';
import './common/services/learningItemAssignmentResource';
import './common/services/learningItemFilesResource';
import './common/services/learningItemLocalizationResource';
import './common/services/learningItemOnlineExamResource';
import './common/services/learningItemOnlineLessonResource';
import './common/services/learningItemResource';
import './common/services/learningItemSBCourseResource';
import './common/services/learningItemWebinarResource';
import './common/services/learningItemWebinarArchivesResource';
import './common/services/learningItemSeminarsResource';
import './common/services/learningItemTranslationsService';
import './common/services/learningItemTypeResource';
import './common/services/learningItemUrlLocalizationResource';
import './common/services/learningPathResource';
import './common/services/learningPathVersionLocalizationResource';
import './common/services/learningPathVersionOpenBadgesResource';
import './common/services/learningPathVersionResource';
import './common/services/learningPathVersionStorefrontCrossSellResource';
import './common/services/learningPathVersionStorefrontResource';
import './common/services/learningPathVersionViewModelResource';
import './common/services/learningPathVersionVisibilityResource';
import './common/services/learningPlanResource';
import './common/services/learningPlanService';
import './common/services/localizationResource';
import './common/services/logoService';
import './common/services/logResource';
import './common/services/menuService';
import './common/services/messageService';
import './common/services/myAccountResource';
import './common/services/myNotificationResource';
import './common/services/myPointsLeaderboardResource';
import './common/services/notificationResource';
import './common/services/onlineExamsHistoryResource';
import './common/services/orderResource';
import './common/services/orderItemInventoryResource';
import './common/services/organizationsResource';
import './common/services/organizationsFilterResource';
import './common/services/pageFilesResource';
import './common/services/pagesResource';
import './common/services/pauseLearnerEmailService';
import './common/services/practicalEvaluationHistoryResource';
import './common/services/productResource';
import './common/services/publicOpenBadgesResource';
import './common/services/publicResource';
import './common/services/recognitionService';
import './common/services/reportResource';
import './common/services/rolesResource';
import './common/services/scoreAssignmentsResource';
import './common/services/scoreOnlineExamResource';
import './common/services/scoreWorkHistoryResource';
import './common/services/scormService';
import './common/services/seedDataService';
import './common/services/sessionService';
import './common/services/shoppingCartResource';
import './common/services/shoppingCartService';
import './common/services/subscriptionCheckoutService';
import './common/services/subscriptionResource';
import './common/services/takeExamResource';
import './common/services/taxLabelService';
import './common/services/tenantApiToolkitResource';
import './common/services/tenantEnabledLocalizationResource';
import './common/services/tenantExamMessagesResource';
import './common/services/tenantFeaturesResource';
import './common/services/tenantOpenBadgesResource';
import './common/services/tenantPaymentMethodResource';
import './common/services/tenantResource';
import './common/services/tenantTaxCountryResource';
import './common/services/tierPriceResource';
import './common/services/timeZoneResource';
import './common/services/timeZoneService';
import './common/services/userHubService';
import './common/services/versionService';
import './common/services/webJobService';
import './common/services/webinarsResource';
import './common/translation/translation';
import './common/services/frameworkService';
import './common/services/checkoutResource';
import './common/services/checkoutService';
import './common/factory/';
import './common/filters/';
import './common/directives/';
import './main.component';
import './mainFooter.component';
import './admin/mainMenu.component';
import './home.component';
import './site';
import './account/certificates/accountCertificates.component';
import './account/edit/aboutMe';
import './account/edit/myPreferencesCtrl';
import './account/edit/profilePictureCtrl';
import './account/exam/examDetails';
import './account/exam/examValidation';
import './account/exam/launchExam';
import './account/exam/takeExamQuestion';
import './account/exam/takeExamResult';
import './account/exam/takeExamSummary';
import './account/externalLogin/connectExternalLogin';
import './account/gamification/myPoints';
import './account/gamification/myTier';
import './account/learnerAccess/learningItemLearnerAccessModal.component';
import './account/learnerAccess/learningItemType/assignmentLearnerAccess.component';
import './account/learnerAccess/learningItemType/downloadsLearnerAccess.component';
import './account/learnerAccess/learningItemType/externalQualificationLearnerAccess.component';
import './account/learnerAccess/learningItemType/externalUrlLearnerAccess.component';
import './account/learnerAccess/learningItemType/history/assignmentHistoryLearner';
import './account/learnerAccess/learningItemType/history/workHistoryHistoryLearner';
import './account/learnerAccess/learningItemType/history/externalQualificationHistoryLearner';
import './account/learnerAccess/learningItemType/history/learningJournalHistoryLearner';
import './account/learnerAccess/learningItemType/history/practicalEvaluationHistoryLearner';
import './account/learnerAccess/learningItemType/history/seminarHistoryLearner';
import './account/learnerAccess/learningItemType/history/webinarHistoryLearner';
import './account/learnerAccess/learningItemType/learningJournalLearnerAccess.component';
import './account/learnerAccess/learningItemType/onlineExamLearnerAccess.component';
import './account/learnerAccess/learningItemType/onlineExamLeanerAccessSelectExamSession';
import './account/learnerAccess/learningItemType/onlineLessonLearnerAccess.component';
import './account/learnerAccess/learningItemType/practicalEvaluationLearnerAccess.component';
import './account/learnerAccess/learningItemType/sbCourseLearnerAccess.component';
import './account/learnerAccess/learningItemType/seminarLearnerAccess.component';
import './account/learnerAccess/learningItemType/seminarLearnerAccessSelectSeminar';
import './account/learnerAccess/learningItemType/seminarLearnerAccessViewSeminarDetailsCtrl';
import './account/learnerAccess/learningItemType/surveyLearnerAccess.component';
import './account/learnerAccess/learningItemType/webinarLearnerAccess.component';
import './account/learnerAccess/learningItemType/webinarLearnerAccessSelectWebinar';
import './account/learnerAccess/learningItemType/workHistoryLearnerAccess.component';
import './account/learningPlan/learningPath/learningPath';
import './account/learningPlan/learningPlan';
import './account/learningPlan/quickLinks/quickLinksCtrl';
import './account/missingRequiredRegistrationFields';
import './account/myAccount';
//import './account/openBadges/badgeDetails';
//import './account/openBadges/badges';
import './account/openBadges/myBadges';
//import './account/openBadges/sharing/viaEmailCtrl';
import './account/openBadges/sharing/viaFacebookCtrl';
//import './account/openBadges/sharing/viaLinkedInCtrl';
//import './account/openBadges/uploadBadge';
import './account/orders/myOrders';
import './account/redeemCode/accountRedeemCode';
import './account/transcript/transcriptCtrl';
import './accounts/delete/deleteAccount.component';
import './accounts/edit/billingInformationCtrl';
import './accounts/edit/personalInformationCtrl';
import './checkout/checkoutStep1Register';
import './checkout/checkoutStep2Address';
import './checkout/checkoutStep3Payment.component';
import './checkout/checkoutStep4Confirm.component';
import './checkout/checkoutStep5Complete.component';
import './checkout/checkoutWizard';
import './checkout/payments/bamboraPaymentFormConfirmation';
import './checkout/payments/monerisHostedPayPageConfirmation';
import './checkout/payments/payPalExpressCheckoutConfirmation';
import './customPages/customPage.component';
import './customPages/homePage';
import './dashboard/dashboard.component';
import './dashboard/dashboardCommon.component';
import './dashboard/dashboardAdmin.component';
import './dashboard/dashboardLearner.component';
import './dashboard/dashboardSuperAdmin.component';
import './forums/disqus/disqusCtrl';
import './inventory/inventoryAssignModalCtrl';
import './inventory/inventoryDetails';
import './inventory/inventorySummaryList';
import './modals/cropPicture/cropPictureModalCtrl';
import './modals/externalQualificationHistoryFiles/externalQualificationHistoryFilesModalCtrl';
import './modals/learnerOnlineLesson/learnerViewOnlineLessonModalCtrl';
import './modals/learnerSBCourse/learnerViewSBCourseModalCtrl';
import './modals/learningJournalHistoryFiles/learningJournalHistoryFilesModalCtrl';
import './modals/practicalEvaluationHistoryFiles/practicalEvaluationHistoryFilesModalCtrl';
import './modals/recognition/recognitionModalCtrl';
//import './navBar/navBar';
//import './orders/orderDetails.component';
import './public/badgeCriteria';
//import './public/badgeEvidence';
import './public/contactUsCtrl';
import './public/examAttemptRequestApproval';
//import './public/externalBadgeEvidence';
import './public/notificationUnsubscribe';
import './public/passwordReset';
import './public/preregistration';
import './public/privacyModalCtrl';
import './public/requestPasswordReset';
import './public/selfRegistration.component';
import './public/verifyEmail';
import './public/viewOrderDetails.component';
import './security/accessDenied';
import './security/notFound.component';
import './security/signIn.component';
//import './storefront/catalogItem.component';
//import './storefront/catalog.component';
//import './storefront/catalogPath';
//import './storefront/shoppingCart';
import './admin/mainMenu.component';
import './accounts/accounts.component';
import './accounts/add/addAccountCtrl';
import './accounts/add/bulkAddAccounts';
import './accounts/edit/accountInformationCtrl';
import './accounts/edit/accountSettingsCtrl';
import './accounts/edit/assignedGroupsCtrl';
import './accounts/edit/resetPasswordCtrl';
import './accounts/learningPlan/adminLearningPlan';
import './accounts/learningPlan/learningPath/adminLearningPath';
import './accounts/orders/accountsOrders';
import './accounts/profile.component';
import './assignments/path/learningPathAssign';
import './assignments/path/steps/learningPathSelect';
import './assignments/path/steps/selectAssignTo/groupSelect';
import './assignments/path/steps/selectAssignTo/personSelect';
import './assignments/pathsToGroupsAssignments';
import './assignments/pathsToLearnersAssignments';
import './discounts/discountForm';
import './discounts/discountList';
import './exams/addCategoryModalCtrl';
import './exams/addExamModalCtrl';
import './exams/editExamCategory';
import './exams/editExam.component';
import './exams/examQuestion';
//import './exams/importExamQuestions';
import './exams/manageCategories';
import './exams/manageExams';
import './exams/manageQuestions';
import './evaluations/assignments/scoreAssignment';
import './evaluations/assignments/scoreAssignmentList';
import './evaluations/workHistory/scoreWorkHistory';
import './evaluations/workHistory/scoreWorkHistoryList';
import './evaluations/externalQualifications/externalQualificationForm';
import './evaluations/externalQualifications/externalQualificationHistory';
import './evaluations/externalQualifications/manageExternalQualifications';
import './evaluations/onlineExams/addManualScoreCtrl';
import './evaluations/onlineExams/editExamAttemptCtrl';
import './evaluations/onlineExams/manageOnlineExams';
import './evaluations/onlineExams/modal/onlineExamAddAttemptModalCtrl';
import './evaluations/onlineExams/onlineExamActivationsHistory';
import './evaluations/onlineExams/onlineExamHistory';
import './evaluations/practicalEvaluations/managePracticalEvaluations';
import './evaluations/practicalEvaluations/practicalEvaluationForm';
import './evaluations/practicalEvaluations/practicalEvaluationHistory';
import './evaluations/scoreOnlineExams/scoreExam';
import './evaluations/scoreOnlineExams/scoreExamList';
import './learningItems/add/learningItemAdd';
import './learningItems/add/steps/learningItemAddSpecificInfo';
import './learningItems/add/steps/learningItemType/learningItemAddAssignment';
import './learningItems/add/steps/learningItemType/learningItemAddDownloads';
import './learningItems/add/steps/learningItemType/learningItemAddLearningJournal';
import './learningItems/add/steps/learningItemType/learningItemAddOnlineLesson';
import './learningItems/add/steps/learningItemType/learningItemAddPracticalEvaluation';
import './learningItems/add/steps/learningItemType/learningItemAddUrl';
import './learningItems/add/steps/learningItemType/learningItemAddWebinar';
import './learningItems/add/steps/learningItemType/learningItemAddWorkHistory';
import './learningItems/add/steps/learningItemType/onlineExam/examSelectionModalCtrl';
import './learningItems/add/steps/learningItemType/onlineExam/learningItemAddOnlineExam';
import './learningItems/categoriesAndBands/categoriesAndBandsManage';
import './learningItems/categoriesAndBands/modals/addPathsModalCtrl';
import './learningItems/categoriesAndBands/modals/translateBandModalCtrl';
import './learningItems/categoriesAndBands/modals/translateCategoryModalCtrl';
import './learningItems/edit/learningItemEditCommonInfoModalCtrl';
import './learningItems/edit/learningItemEdit';
import './learningItems/edit/learningItemType/learningItemEditAssignmentModalCtrl';
import './learningItems/edit/learningItemType/learningItemEditAssignmentTab';
import './learningItems/edit/learningItemType/learningItemEditDownloadableTab';
import './learningItems/edit/learningItemType/learningItemEditLearningJournalTab';
import './learningItems/edit/learningItemType/learningItemEditOnlineExamModalCtrl';
import './learningItems/edit/learningItemType/learningItemEditOnlineExamTab';
import './learningItems/edit/learningItemType/learningItemEditOnlineLessonModalCtrl';
import './learningItems/edit/learningItemType/learningItemEditOnlineLessonTab';
import './learningItems/edit/learningItemType/learningItemEditPracticalEvaluationTab';
import './learningItems/edit/learningItemType/learningItemEditSBCourseModalCtrl';
import './learningItems/edit/learningItemType/learningItemEditSBCourseTab';
import './learningItems/edit/learningItemType/learningItemEditUrlModalCtrl';
import './learningItems/edit/learningItemType/learningItemEditUrlModalCtrl';
import './learningItems/edit/learningItemType/learningItemEditUrlTab';
import './learningItems/edit/learningItemType/learningItemEditWebinarModalCtrl';
import './learningItems/edit/learningItemType/learningItemEditWebinarTab';
import './learningItems/edit/learningItemType/learningItemEditWebinarTypeModalCtrl';
import './learningItems/learningItemList';
import './learningItems/preview/learningItemPreviewModalCtrl';
import './learningItems/preview/learningItemType/assignmentPreviewCtrl';
import './learningItems/preview/learningItemType/downloadsPreviewCtrl';
import './learningItems/preview/learningItemType/externalUrlPreviewCtrl';
import './learningItems/preview/learningItemType/learningJournalPreviewCtrl';
import './learningItems/preview/learningItemType/onlineExamPreviewCtrl';
import './learningItems/preview/learningItemType/onlineLessonPreviewCtrl';
import './learningItems/preview/learningItemType/practicalEvaluationPreviewCtrl';
import './learningItems/preview/learningItemType/seminarPreviewCtrl';
import './learningItems/preview/learningItemType/webinarPreviewCtrl';
import './learningItems/preview/learningItemType/workHistoryPreviewCtrl';
import './learningPaths/add/learningPathForm';
import './learningPaths/customCertificates';
import './learningPaths/learningPaths';
import './learningPaths/modals/addItemsModalCtrl';
import './learningPaths/modals/editCertificateModalCtrl';
import './learningPaths/modals/editPathExpiryModalCtrl';
import './learningPaths/modals/selectIconsModalCtrl';
import './learningPaths/modals/translatePathModalCtrl';
import './learningPaths/modals/translateVersionNameModalCtrl';
import './learningPaths/version/informationItem/learningPathVersionInformationItemCtrl';
import './learningPaths/version/learningPathVersion.component';
import './learningPaths/version/openBadges/learningPathVersionOpenBadges';
import './learningPaths/version/visibility/learningPathVersionVisibility.component';
import './learningPaths/version/storefrontConfig/configureStorefront';
import './learningPaths/version/storefrontConfig/learningPathVersionStorefrontCrossSell';
import './learningPaths/version/storefrontConfig/learningPathVersionStorefrontCtrl';
import './learningPaths/version/storefrontConfig/learningPathVersionStorefrontDetail';
import './learningPaths/version/storefrontConfig/learningPathVersionStorefrontPricing';
import './learningPaths/visibility/visibilityWizard.component';
import './learningPaths/visibility/steps/visibilityWizardStep1.component';
import './learningPaths/visibility/steps/visibilityWizardStep2.component';
import './modals/adminOnlineLesson/adminViewOnlineLessonModalCtrl';
import './modals/customPages/customPageMediaBrowserCtrl';
//import './orders/orderList.component';
//import './orders/orderRefund';
//import './people/organizations/organizationBulkAdd';
//import './people/organizations/organizationList';
//import './people/organizations/organizationModalFormCtrl';
//import './products/product.component';
//import './products/productCrossSell.component';
//import './products/productInformation.component';
//import './products/productPricing.component';
import './reports/myReports';
import './reports/orderDetailsReport';
import './reports/orderSummaryReport';
import './reports/scheduledReportForm';
import './reports/scheduledReports';
import './reports/sharedReports';
import './reports/testItemDetailsReport';
import './reports/testItemDetailsReportList';
import './seminar/addRegistrantsCtrl';
import './seminar/addCompletedLearnersCtrl';
import './seminar/seminarList';
import './seminar/seminarForm.component';
import './settings/apiToolkit/apiToolkit';
import './settings/connections/bambooHR/bambooHRv1Import';
import './settings/connections/connectionsList';
import './settings/connections/disqus/disqusV3';
import './settings/connections/dynamics365/dynamics365V82';
import './settings/connections/skillBuilderBridge/skillBuilderBridge';
import './settings/connections/taxJar/taxJarSalesTaxV2';
import './settings/customPages/pageForm';
import './settings/customPages/pageList';
import './settings/dataPrivacy/dataPrivacy.component';
import './settings/gamification/configureLeaderboardSystem';
import './settings/gamification/configurePointSystem';
import './settings/gamification/configureTierSystem';
import './settings/gamification/enableGamification';
import './settings/general/contactPreferences/contactPreferences';
import './settings/general/languages/learningItems/learningItemManageTranslations';
import './settings/general/languages/learningItems/learningItemManageTranslationsEdit';
import './settings/general/languages/learningItems/learningItemTranslationsImportFileModalCtrl';
import './settings/general/languages/secondary/secondaryLanguages';
import './settings/general/location/settingsLocation';
import './settings/general/searchEngine/settingsGeneralSearchEngine';
import './settings/general/timeZone/settingsTimeZone';
//import './settings/languagesAndTimeZone/languageAndTimeZoneDashboardCtrl';
import './settings/notifications/editNotificationTemplate';
import './settings/notifications/notificationsDashboard';
import './settings/notifications/pauseLearnerEmailsModalCtrl';
import './settings/notifications/pauseLearnerEmailsNoteCtrl';
import './settings/openBadges/openBadgesSettings';
import './settings/registration/customRegistrationFields/customRegistrationFields';
import './settings/registration/externalLoginConfigurations/add/addExternalLogin';
import './settings/registration/externalLoginConfigurations/edit/editExternalLoginConfiguration';
import './settings/registration/externalLoginConfigurations/externalLoginConfigurations';
import './settings/registration/selfRegistrationSettings/selfRegistrationSettings';
import './settings/registration/tenantRegistrationQuestions/tenantRegistrationQuestions.component';
import './settings/registration/tenantRegistrationQuestions/tenantRegistrationQuestionsModalCtrl';
import './settings/setup/gettingStarted';
import './settings/storefront/paymentMethod/affiniPayHostedPage';
import './settings/storefront/paymentMethod/bamboraCustomCheckout';
import './settings/storefront/paymentMethod/bamboraPaymentForm';
import './settings/storefront/paymentMethod/finalizePayPalExpressCheckout';
import './settings/storefront/paymentMethod/monerisHostedPayPage';
import './settings/storefront/paymentMethod/paypalExpressCheckout';
import './settings/storefront/paymentMethod/paymentMethodPurchaseOrder.component';
import './settings/storefront/storefrontSettings.component';
//import './settings/storefront/tierPrice/reorderTierPriceModalCtrl';
import './settings/storefront/tierPrice/tierPriceModalCtrl';
import './settings/subscription/billingHistory';
import './settings/subscription/checkout/payments/subscriptionPayPalExpressCheckoutConfirmation';
import './settings/subscription/checkout/subscriptionCheckoutStep1Address';
import './settings/subscription/checkout/subscriptionCheckoutStep2Payment';
import './settings/subscription/checkout/subscriptionCheckoutStep3Confirm';
import './settings/subscription/checkout/subscriptionCheckoutStep4Complete';
import './settings/subscription/checkout/subscriptionCheckoutWizard';
import './settings/subscription/currentSubscription';
import './settings/subscription/invoiceDetails';
import './settings/subscription/subscription';
import './settings/subscription/calculator/calculator';
import './settings/subscription/types/annual';
import './settings/subscription/types/enterprise';
import './settings/subscription/types/freeTrial';
import './settings/subscription/types/monthly';
import './settings/theme/colors/colorSelector';
import './settings/theme/colors/colors';
import './settings/theme/evaluator/evaluatorSettings.component';
import './settings/theme/footer/footerSettings.component';
import './settings/theme/logo/logoCustomization';
import './settings/theme/reassignments/reassignSettings.component';
import './settings/theme/learning-items/learningItemSettings.component';
import './settings/theme/signature/signatureCustomization.component';
import './settings/user/loginPageDefaults/loginPageDefaults';
import './settings/user/options/userOptions';
import './settings/dataPrivacy/dataPrivacy.component';
import './webinars/registrants/webinarRegistrantsListCtrl';
